import { EpimsBaseEntityDto } from './epim-base.dto';

export class MeasuringFactorDto extends EpimsBaseEntityDto {
  MeasureId: string;
  Acre: number;
  Hectares: number;
  SqKM: number;
  SqM: number;
  SqF: number;
  Rood: number;
  Perche: number;
  Unit: number;
  Plot: number;
  SubscriptionUserId: string;
  MeasureName: string;
  length: number;
  // Version: number;
  }
